import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    text-align: center;
    max-width: 456px;
    background-color: ${theme.color.background.neutral.default};
    border-radius: ${theme.border.radius.default};
    padding: ${theme.spacing.km6};
    opacity: 1;
    transition: opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  `}
`;

export const WrapperIcon = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin: 0 auto;
    border-radius: ${theme.border.radius.circle};
    background: ${theme.color.background.success.default};
    color: ${theme.color.text.neutral.inverted};
  `}
`;
